import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ComercialProductResponseDTO, CommonDataDTO } from '@app/requests/model/combos-model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import {
  CommercialProductRequestDTO,
  CustomerInterestResponse,
  TariffRequestDTO,
  TariffSectorResponseDTO,
  TariffSheetRequest,
  TariffSheetCommon,
  TariffSheetTarTwo,
  TariffTradeDiscount,
  TariffTradeDiscountResponse,
  TariffVersionDTO,
  TradeDiscountDTO,
  TariffSheetResponseDTO,
} from '../model/tariffs-model';

@Injectable()
export class TariffsApi {
  constructor(private _http: HttpClient) {}

  getCommercialProductByFilter(filter: CommercialProductRequestDTO): Observable<ComercialProductResponseDTO[]> {
    return this._http.post<ComercialProductResponseDTO[]>(
      environment.URL_BASE_REQUEST + environment.subUrlCommercialProduct,
      filter
    );
  }

  getSectorByEstablishment(establishment: string): Observable<TariffSectorResponseDTO[]> {
    return this._http.post<TariffSectorResponseDTO[]>(
      environment.URL_BASE_REQUEST + environment.subURLCombosSectorByEstablishment,
      null,
      {
        params: { establishmentId: establishment },
      }
    );
  }

  getTariffsByFilter(filter: TariffRequestDTO): Observable<TariffVersionDTO[]> {
    return this._http.post<TariffVersionDTO[]>(
      environment.URL_BASE_REQUEST + environment.subURLCombosTariffByFilter,
      filter
    );
  }

  getTariffSheetTable(request: TariffSheetRequest): Observable<TariffSheetResponseDTO> {
    return this._http.post<TariffSheetResponseDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlTariffSheetTable,
      request
    );
  }

  getTradeDiscount(request: TradeDiscountDTO): Observable<TariffTradeDiscountResponse> {
    return this._http.post<TariffTradeDiscountResponse>(
      environment.URL_BASE_REQUEST + environment.subUrlTradeDiscount,
      request
    );
  }

  getInterestCommercialProduct(establishmentId: string): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_REQUEST + environment.subUrlTariffInterestCommercialProduct,
      null,
      { params: new HttpParams().set('establishmentId', establishmentId) }
    );
  }

  getTariffInterestCommercial(request: TariffSheetRequest): Observable<CustomerInterestResponse> {
    return this._http.post<CustomerInterestResponse>(
      environment.URL_BASE_REQUEST + environment.subUrlCommercialInterest,
      request
    );
  }

  getCicoCommercialProduct(establishmentId: string): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_REQUEST + environment.subUrlCiCoCommercialProduct,
      null,
      { params: new HttpParams().set('establishmentId', establishmentId) }
    );
  }
}
